'use client';
import { keyframes } from '@emotion/react';
import { ArrowIcon } from 'common/components/icons/ArrowIcon';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import type { OS } from 'src/shared/types';

const bouncing = keyframes`
  from {
    transform: translate3d(0,1em,0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
`;

export const BounceTopArrow = ({ os, isBrowserSafari }: {os: OS | undefined; isBrowserSafari: boolean}) => {
    return (
        <Grid item xs={12}>
            <Box sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
            }}
            >
                {os === 'ios' && isBrowserSafari && (
                    <ArrowIcon sx={{
                        animation: `${bouncing} 1.5s ease-in-out infinite`,
                        height: '36px',
                        width: '28px',
                    }}
                    />
                )}
            </Box>
        </Grid>
    );
};
